import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Avatar,
  Tooltip,
  Box,
  Chip
} from '@mui/material';
import { Payment } from '@mui/icons-material';

import { formatDate } from '../../resources/functions';
import { Tariff } from '../../resources/types/balanceTypes';

interface Props {
  items: Tariff[];
  openDialog: (tariff: Tariff | null) => () => void;
  onDelete: (_id: string | undefined) => void;
}

const TariffsTable = ({
  items,
  openDialog,
  onDelete
}: Props) => {
  const cellStyles = {
    color: '#FFFFFF',
    fontWeight: 600
  };

  return (
    <TableContainer sx={{ mt: 3 }} component={Paper}>
      <Table>
        <TableHead sx={{ bgcolor: '#4ECDC4' }}>
          <TableRow>
            <TableCell sx={cellStyles}>Іконка</TableCell>
            <TableCell sx={cellStyles}>Назва</TableCell>
            <TableCell sx={cellStyles}>Тип</TableCell>
            <TableCell sx={cellStyles}>Ціна</TableCell>
            <TableCell sx={cellStyles}>Дата створення</TableCell>
            <TableCell sx={cellStyles}>Дата оновлення</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(tariff => {
            if (!tariff.from && !tariff.to) {
              return (
                <TableRow 
                  hover 
                  key={tariff._id} 
                  onClick={openDialog(tariff)}
                  sx={{
                    '&:hover': {
                      bgcolor: 'rgba(78, 205, 196, 0.08)'
                    }
                  }}
                >
                  <TableCell>
                    <Tooltip title="Тариф" arrow>
                      <Avatar
                        sx={{
                          width: 40,
                          height: 40,
                          backgroundColor: 'rgba(78, 205, 196, 0.12)',
                          borderRadius: '8px'
                        }}
                      >
                        <Payment sx={{ fontSize: 24, color: '#4ECDC4' }} />
                      </Avatar>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{tariff.name}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {tariff.type}
                      {tariff.type === 'start' && tariff.holdAmount != null && (
                        <Chip
                          label={`Hold: ${tariff.holdAmount}`}
                          size="small"
                          sx={{
                            backgroundColor: 'rgba(78, 205, 196, 0.12)',
                            color: '#4ECDC4',
                            fontWeight: 600,
                            fontSize: 11
                          }}
                        />
                      )}
                      {tariff.type === 'start' && tariff.relocationFee != null && (
                        <Chip
                          label={`Relocation: ${tariff.relocationFee}`}
                          size="small"
                          sx={{
                            backgroundColor: 'rgba(255, 152, 0, 0.12)',
                            color: '#FF9800',
                            fontWeight: 600,
                            fontSize: 11
                          }}
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {tariff?.price?.toLocaleString()}
                  </TableCell>
                  <TableCell>{formatDate(tariff.createdAt)}</TableCell>
                  <TableCell>{formatDate(tariff.updatedAt)}</TableCell>
                </TableRow>
              );
            }
            return false;
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TariffsTable;
